//=================================================//
//    SHUFFLED INK | ART TEMPLATES MASONRY GRID    //
//=================================================//

(function($) {
	$(document).ready(function() {

		// Template check
		if ( $('body').hasClass( 'page-template-page-art-templates' ) ) {


			// Isotope
			var grid = $( '.art-templates' ).isotope({
				itemSelector		: '.grid-item',
				percentPosition		: true,
				// stagger				: 30,
				masonry: {
					columnWidth		: '.grid-sizer',
				}
			});

			// Fix overlaps
			grid.imagesLoaded().progress( function() {
				grid.isotope('layout');
			});


		} // templates page
	}); // document.ready
})(jQuery);
